import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { handleExternalAuth } from "../redux/authSlice";

function AuthCallback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleAuth = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");

      if (!code) {
        console.error("No authentication code found");
        navigate("/Logueo-Fallido", {
          state: { error: "Authentication failed. Please try again." },
        });
        return;
      }

      try {
        await dispatch(handleExternalAuth(code)).unwrap();
        navigate("/");
      } catch (error) {
        console.error("Authentication failed:", error);
        navigate("/error-page-Login", {
          state: {
            errorData: {
              status: error.status,
              message: error.message,
            },
          },
        });
      }
    };

    handleAuth();
  }, [dispatch, navigate, location]);

  return <div>Autenticando...</div>;
}

export default AuthCallback;
